import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { Transition, useStyles } from './styles';

const CampanasDetails = ({ details, onClose, openDetails }) => {
  const classes = useStyles();
  console.log(details);
  return (
    <Dialog
      open={openDetails}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogContent style={{ display: 'flex', flexWrap: 'wrap' }}>

      <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Estado Global</Typography>
          <Typography className={classes.subTitles}>
            {details.estado_global === '1' ? 'Activo' : 'Inactivo'}
          </Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Estado</Typography>
          <Typography className={classes.subTitles}>
            {details.estado === '1' ? 'Activo' : 'Inactivo'}
          </Typography>
        </div>

        <div className={classes.linesContainer}>
          <Typography className={classes.titles}>Nombre Campaña</Typography>
          <Typography className={classes.subTitles}>
            {details.nombre_campana}
          </Typography>
        </div>
        
        { details.estado_global != 1 ? (
          <div className={classes.linesContainer}>
          <Typography className={classes.titles}>Ciudades</Typography>
          <div>
            {details.campanasCiudades?.map((est) => (
              <Typography key={est.id_ciudad} className={classes.subTitles}>
                {est. nombre_ciudad} - {est.nombre_departamento}
              </Typography>
            ))}
          </div>
        </div>
        ): null}

        { details.estado_global != 1 ? (
          <div className={classes.linesContainer}>
            <Typography className={classes.titles}>Establecimientos</Typography>
            <div>
              {details.campanasEstablecimientos?.map((est) => (
                <Typography key={est.id_establecimiento} className={classes.subTitles}>
                  {est.nombre_establecimiento_ciudad}
                </Typography>
              ))}
            </div>
          </div>
        ): null}
        
        { details.estado_global != 1 ? (
          <div className={classes.linesContainer}>
            <Typography className={classes.titles}>Vehículos</Typography>
            <div>
              {details.campanasVehiculos?.map((est) => (
                <Typography key={est.id_vehiculo} className={classes.subTitles}>
                  {est.linea}
                </Typography>
              ))}
            </div>
          </div>
        ): null}
      
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="warning">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CampanasDetails;
